export default __webpack_public_path__ + "static/media/summary.dcb3af2f.svg";